<!-- Gestão completa (Unidades) do cliente, reusada em modo embutido (contexto). -->
<app-unidade-de-medida *ngIf="montado"
  [embutido]="true"
  [empresaContextoId]="clienteEmpresaId">
</app-unidade-de-medida>
